import { ValidationAdapter } from '@/forms/core';
import type {
  FormConditionalValidation,
  FormValidationSchema,
} from '@/forms/typings';
import { generateConditionalValidation } from './generateConditionalValidation';
import { generateConditionalValidationFieldIds } from './generateConditionalValidationFieldIds';

/** Requires an address group's source choice while the group itself is validated. */
export const createAddressLinkYupSchema = (
  conditions: FormConditionalValidation[] | undefined,
): FormValidationSchema => {
  const Yup = ValidationAdapter.getLibrary();
  const base = Yup.string();
  const required = base.required('Required');

  if (!conditions?.length) return required as FormValidationSchema;

  return base.when(
    generateConditionalValidationFieldIds(conditions),
    (values, schema) =>
      generateConditionalValidation(conditions, values) ? required : schema,
  ) as FormValidationSchema;
};
